<img src="/assets/images/logo.jpg" alt="Pre-Plan by Harris Funeral Home"
    style="height: auto; margin: 0 auto; width: 250px;" />

<router-outlet>
    <app-spinner></app-spinner>
</router-outlet>